import { render, staticRenderFns } from "./NewChatDetail.vue?vue&type=template&id=005a23c2"
import script from "./NewChatDetail.vue?vue&type=script&lang=js"
export * from "./NewChatDetail.vue?vue&type=script&lang=js"
import style0 from "./NewChatDetail.vue?vue&type=style&index=0&id=005a23c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports